'use strict';

const { commonSigninInit } = require('./common_signin');

// Generated by CoffeeScript 1.12.7
/* global document:false, window:false */
const indexOf =
  [].indexOf ||
  function(item) {
    for (let i = 0, l = this.length; i < l; i++) {
      if (i in this && this[i] === item) return i;
    }
    return -1;
  };

require('./subscriptions_ui');

const GrouponSDSCommonClass = function() {
  function GrouponSDSCommon() {}

  const TWENTYFOUR_HOURS_LIFE_IN_MILLISECONDS = 24 * 60 * 60 * 1000;

  const NAQ_APP_NAMES = ['merchant-page', 'coupon_itier'];

  const COMMON_MOBILE_DISPLAY_EXPERIMENT =
    'subscription-flow-mobile-show-experiment';

  const SEO_MOBILE_DISPLAY_EXPERIMENT =
    'subscription-flow-mobile-seo-show-experiment';

  const Cookie = window.Cookie;

  const OptimizeSuite = window.OptimizeSuite;

  const Optimize = window.Optimize;

  const dataLayer = window.dataLayer;

  const TrackingHub = window.TrackingHub;

  const Finch = window.Finch;

  GrouponSDSCommon.log = function(title, info) {
    if (info == null) {
      info = {};
    }
    if ((OptimizeSuite != null ? OptimizeSuite.TrackingHub : void 0) != null) {
      if (info['goalType'] == null) {
        info['goalType'] = 'subscription';
      }
      if (info['uiSource'] == null) {
        info['uiSource'] = 'sds';
      }
      try {
        return OptimizeSuite.TrackingHub.add(title, info);
      } catch (error) {
        return null;
      }
    }
    return null;
  };

  GrouponSDSCommon.dismissModal = function(container) {
    if (container != null) {
      container.style.display = 'none';
      if (typeof container.hideSpotlight === 'function') {
        container.hideSpotlight();
      }
      //document.getElementById('global-container').style.display = '';
    }
  };

  GrouponSDSCommon.getAppName = function() {
    let ref, ref1;
    const data_app = document
      .getElementsByTagName('head')[0]
      .getAttribute('data-app');
    if (data_app != null && data_app.length > 0) {
      return encodeURIComponent(data_app);
    } else if (
      (Optimize != null
        ? (ref = Optimize.suiteData) != null
          ? ref.app
          : void 0
        : void 0) != null &&
      (Optimize != null
        ? (ref1 = Optimize.suiteData) != null
          ? ref1.app.length
          : void 0
        : void 0) > 0
    ) {
      return encodeURIComponent(Optimize.suiteData.app);
    }
    return null;
  };

  GrouponSDSCommon.showSuccessNotification = function() {
    const email_subscription_subanner = document.getElementById(
      'email_subscription_subanner'
    );
    if (email_subscription_subanner !== null) {
      //email_subscription_subanner.style.display = '';
      email_subscription_subanner.addEventListener('click', () => {
        //email_subscription_subanner.classList.remove('slide-down');
        //email_subscription_subanner.classList.add('slide-up');
        email_subscription_subanner.style.display = '';
        email_subscription_subanner.classList.add('fadeObject');
      });
    }
    const notice_banner = document.getElementById('notice_banner');
    if (notice_banner !== null) {
      notice_banner.style.display = '';
    }
  };

  GrouponSDSCommon.gtmSubscribeEvent = function() {
    return dataLayer != null
      ? dataLayer.push({
          event: 'subscription',
        })
      : void 0;
  };

  GrouponSDSCommon.gtmSubscribeLandingEvent = function(subsave) {
    if (subsave == null) {
      subsave = false;
    }
    if (subsave) {
      return dataLayer != null
        ? dataLayer.push({
            event: 'subscription/save',
          })
        : void 0;
    } else {
      return dataLayer != null
        ? dataLayer.push({
            event: 'subscription/landing',
          })
        : void 0;
    }
  };

  GrouponSDSCommon.isSubForced = function() {
    let ref, ref1;
    return (
      (typeof window !== 'undefined' && window !== null
        ? (ref = window.location) != null
          ? (ref1 = ref.href) != null
            ? ref1.indexOf('subs_force=')
            : void 0
          : void 0
        : void 0) > -1
    );
  };

  GrouponSDSCommon.fpBasedShow = function(fpShowFn, fpHideFn) {
    const fpCookie = Cookie.get('subs_fp_hide');
    if (fpCookie == null) {
      return fpShowFn();
    }
    Cookie.unset('subs_fp_hide', document.domain);
    const fpHide = fpCookie === '1';
    if (fpHide) {
      Cookie.set('hide_sub_modal', 1, {
        maxAge: TWENTYFOUR_HOURS_LIFE_IN_MILLISECONDS,
        domain: document.domain,
      });
      fpHideFn();
    } else {
      fpShowFn();
    }
    return GrouponSDSCommon.log('subscriptionFpHide', {
      fpHide,
    });
  };

  GrouponSDSCommon.isEmailClickTraffic = function() {
    let ref, utm_medium;
    if (
      (typeof window !== 'undefined' && window !== null
        ? (ref = window.location) != null
          ? ref.href
          : void 0
        : void 0) != null
    ) {
      utm_medium = new RegExp('[\\?&]utm_medium=([^&#]*)').exec(
        window.location.href
      );
    }
    if (
      (utm_medium != null &&
        utm_medium[1] != null &&
        utm_medium[1].toLowerCase() === 'email') ||
      (Cookie != null && Cookie.get('_tpmed') === 'email')
    ) {
      return true;
    } else {
      return false;
    }
  };

  GrouponSDSCommon.isMobileSeoSkippingTraffic = function(url) {
    let ref, ref1, ref2, ref3;
    if (url == null) {
      url = window.location.href;
    }
    const isSemTraffic =
      url.indexOf('utm_source') > -1 ||
      url.indexOf('utm_campaign') > -1 ||
      url.indexOf('utm_medium') > -1;
    const isTouchTraffic =
      (ref =
        TrackingHub != null
          ? (ref1 = TrackingHub.user) != null
            ? (ref2 = ref1.deviceType) != null
              ? ref2.toLowerCase()
              : void 0
            : void 0
          : void 0) === 'mobile' || ref === 'tablet';
    if (isSemTraffic || !isTouchTraffic) {
      return false;
    }
    const appName =
      (ref3 = GrouponSDSCommon.getAppName()) != null
        ? ref3.toLowerCase()
        : void 0;
    const mobileHideModal =
      appName === 'seo-platform-itier' || appName === 'merchant-page';
    return mobileHideModal;
  };

  GrouponSDSCommon.isMobileSkippingTraffic = function() {
    let mobileHideModal, ref, ref1, ref2;
    if (
      (TrackingHub != null
        ? (ref = TrackingHub.user) != null
          ? (ref1 = ref.deviceType) != null
            ? ref1.toLowerCase()
            : void 0
          : void 0
        : void 0) !== 'mobile'
    ) {
      return false;
    }
    mobileHideModal = false;
    const appName =
      (ref2 = GrouponSDSCommon.getAppName()) != null
        ? ref2.toLowerCase()
        : void 0;
    if (appName === 'seo-platform-itier' || appName === 'gsm-ita') {
      if (Finch != null) {
        if (typeof Finch.experiment === 'function') {
          Finch.experiment(SEO_MOBILE_DISPLAY_EXPERIMENT, {
            hideForMobile() {
              return (mobileHideModal = true);
            },
            showForMobile() {
              return (mobileHideModal = false);
            },
          });
        }
      }
    } else {
      if (Finch != null) {
        if (typeof Finch.experiment === 'function') {
          Finch.experiment(COMMON_MOBILE_DISPLAY_EXPERIMENT, {
            hideForMobile() {
              return (mobileHideModal = true);
            },
            showForMobile() {
              return (mobileHideModal = false);
            },
          });
        }
      }
    }
    return mobileHideModal;
  };

  GrouponSDSCommon.isNAQTraffic = function(url) {
    let entries, ref, ref1;
    if (url == null) {
      url = window.location.href;
    }
    const appName =
      (ref = GrouponSDSCommon.getAppName()) != null
        ? ref.toLowerCase()
        : void 0;
    const utm_campaign = new RegExp('[\\?&]utm_campaign=([^&#]*)').exec(url);
    if (
      indexOf.call(NAQ_APP_NAMES, appName) >= 0 &&
      (utm_campaign != null ? utm_campaign[1] : void 0) != null
    ) {
      entries = utm_campaign[1].split('_');
      if (
        ((ref1 = entries[5]) != null ? ref1.toLowerCase() : void 0) === 'naq'
      ) {
        return true;
      }
    }
    return false;
  };

  GrouponSDSCommon.isSkippingTraffic = function(url) {
    if (url == null) {
      url = window.location.href;
    }
    const countryDomain = document.domain || '';
    const result = GrouponSDSCommon.isMobileSkippingTraffic();
    if (result && Cookie != null) {
      Cookie.set('hide_sub_modal', 1, {
        maxAge: TWENTYFOUR_HOURS_LIFE_IN_MILLISECONDS,
        domain: countryDomain,
      });
    }
    return result;
  };

  GrouponSDSCommon.setupSuccessCallback = function() {
    let ref;
    const previousDivision = Cookie != null ? Cookie.get('division') : void 0;
    const appName =
      (ref = GrouponSDSCommon.getAppName()) != null
        ? ref.toLowerCase()
        : void 0;
    if (appName === 'pull') {
      return (window._subscriptionSuccessCallback = function(divisionId) {
        let ref1;
        GrouponSDSCommon.gtmSubscribeEvent();
        if (
          !((ref1 = window.SubscriptionsUI) != null
            ? ref1._should_show_doi()
            : void 0) &&
          previousDivision !== divisionId
        ) {
          return (window.location = `/browse/${divisionId}?post_subscribe=true`);
        } else {
          return GrouponSDSCommon.showSuccessNotification();
        }
      });
    } else {
      return (window._subscriptionSuccessCallback = function() {
        GrouponSDSCommon.gtmSubscribeEvent();
        return GrouponSDSCommon.showSuccessNotification();
      });
    }
  };

  return GrouponSDSCommon;
};

function initWhenDependencies() {
  const cond =
    window.Cookie && window.OptimizeSuite && window.TrackingHub && window.Finch;
  if (cond) {
    window.GrouponSDSCommon = GrouponSDSCommonClass();
    window._useSDS = true;
    commonSigninInit();
    return null;
  }
  return setTimeout(initWhenDependencies, 250);
}

initWhenDependencies();
